<ng-container *ngIf="template !== 'list'">
  <div
    class="jb-section-header"
    *ngIf="!!sectionHeader && sectionHeader.length"
  >
    <ng-container *ngFor="let section of sectionHeader; let i = index">
      <div
        class="flex relative h-100 list-of-sections"
        [ngClass]="{
          'bb b--medium-gray':
            i !== sectionHeader.length - 1 &&
            !!sectionHeader[i + 1] &&
            (!sectionHeader[i].data.bgColor ||
              !sectionHeader[i + 1].data.bgColor ||
              sectionHeader[i].data.bgColor ===
                sectionHeader[i + 1].data.bgColor)
        }"
        [attr.data-order]="i + 1"
        *ngIf="!section.hideSection"
      >
        <jb-background
          [color]="section.data?.bgColor"
          [src]="section.data?.bgUrl ? section.data?.bgUrl : ''"
          class="zn-1"
        >
          <dot-background-overlay
            *ngFor="let overlay of section.data?.backgroundOverlay"
            [bgHexColor]="overlay?.bgColorForOverlay"
            [opacity]="overlay?.opacity | jbStringToNumber"
            [opacityType]="overlay?.opacityType"
          >
          </dot-background-overlay>
        </jb-background>
        <div class="center page-margin relative w-100 jb-max-width">
          <jb-section-container
            [list]="template === 'list'"
            [listOfSections]="sectionHeader"
            [centerAligned]="
              section.layout === 'center' || section.data?.layout === 'center'
                ? true
                : false
            "
            [sectionHeaderData]="section"
          ></jb-section-container>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
<!-- list template -->

<ng-container *ngIf="template == 'list'">
  <ng-container *ngIf="!!sectionHeader && sectionHeader.length">
    <ng-container *ngFor="let section of sectionHeader; let i = index">
      <div
        #listOfSections
        [ngClass]="{ 'bb b--medium-gray': i !== sectionHeader.length - 1 }"
        class="relative jb-section-header list-of-sections"
        *ngIf="!section.hideSection"
        [attr.data-order]="i + 1"
      >
        <jb-background
          [color]="section.data?.bgColor"
          [src]="section.data?.bgUrl ? section.data?.bgUrl : ''"
          class="zn-1"
        >
          <dot-background-overlay
            *ngFor="let overlay of section.data?.backgroundOverlay"
            [bgHexColor]="overlay?.bgColorForOverlay"
            [opacity]="overlay?.opacity | jbStringToNumber"
            [opacityType]="overlay?.opacityType"
          >
          </dot-background-overlay>
        </jb-background>
        <div class="page-margin jb-max-width center">
          <jb-section-container
            [list]="true"
            [centerAligned]="section.layout === 'center' ? true : false"
            [sectionHeaderData]="section"
          ></jb-section-container>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
